/*
 * Shared keyboard focus trap for modal dialogs.
 *
 * Load with `defer` BEFORE any script that calls it (component-journey-resume.js,
 * component-delivery-date-picker.js). Deferred scripts execute in document order,
 * so the order of the <script> tags is the dependency order.
 *
 * Usage:
 *   const release = window.FocusTrap.trap(dialogElement);
 *   ...
 *   release(); // when the dialog closes
 *
 * Keeps Tab / Shift+Tab cycling inside `container`. Closing behaviour (Escape,
 * backdrop, close button) is the caller's concern — some dialogs here are
 * deliberately non-dismissible.
 */
if (!window.FocusTrap) {
  const FOCUSABLE_SELECTOR = [
    "a[href]",
    "button:not([disabled])",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    '[tabindex]:not([tabindex="-1"])',
  ].join(", ");

  window.FocusTrap = {
    trap(container) {
      const onKeydown = (event) => {
        if (event.key !== "Tab") return;
        const focusable = Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR));
        if (focusable.length === 0) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const withinContainer = container.contains(document.activeElement);

        if (event.shiftKey) {
          if (!withinContainer || document.activeElement === first) {
            event.preventDefault();
            last.focus();
          }
        } else if (!withinContainer || document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      };
      document.addEventListener("keydown", onKeydown);
      return () => document.removeEventListener("keydown", onKeydown);
    },
  };
}
